$(document).ready(function() {
    $('.product-slider').owlCarousel({
        loop:false,
        margin:30,
        nav:false,
        autoHeight:true,
        dots:true,
        arrows: true,
        responsive:{
            0:{
                items:1
            },
            768:{
                items:2
            },
            1000:{
                items:4
            }
        }
    })
    $('.news-slider').owlCarousel({
        loop:false,
        margin:30,
        nav:false,
        autoHeight:true,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            990:{
                items:2
            }
        }
    })


     $('.video-thumb').on('click', function(ev) {
        $('.video-thumb').addClass('hide-image');

        $("#video")[0].src += "&autoplay=1";
        ev.preventDefault();
     
      });

    $('.nice-select').niceSelect();

    if (window.location.pathname == '/') {
        $("#SortBy").val('').niceSelect('update');
    }


    if (window.location.search.indexOf('sort_by') > -1) {
        var value = getQueryParam("sort_by", location.search);
        if (value != 'Sort+By') {
            $("#SortBy").val(value).niceSelect('update');
        }
    }

    if (window.location.href.indexOf('all/') > -1) {
        var elem  = window.location.href.split('all/')[1];
        if (elem.indexOf('?') > -1) {
            var elem2  = '/collections/all/' + elem.split('?')[0];
            $("#BrowseBy").val(elem2).niceSelect('update');
        } else {
            elem = '/collections/all/' + elem;
            console.log(elem);
            $("#BrowseBy").val(elem).niceSelect('update');
        }
    }

    // Side Menu
    var $toggleButton = $('.toggle-button'),
        $menuWrap     = $('.menu-wrap'),
        $sidebarArrow = $('.sidebar-menu-arrow');
        $menuOverlay  = $('.menu-overlay');

    // Hamburger button
    $toggleButton.on('click', function() {
        $(this).toggleClass('button-open');
        $menuWrap.toggleClass('menu-show');
        $menuOverlay.toggleClass('overlay-open');
    });
    $menuOverlay.on('click', function() {
        $(this).removeClass('overlay-open');
        $toggleButton.removeClass('open');
        $menuWrap.toggleClass('menu-show');
    });

    // Sidebar navigation arrows
    $sidebarArrow.click(function() {
        $(this).next().slideToggle(300);
    });
    // End
});

function getQueryParam(key, url) {
    // Find the key and everything up to the ampersand delimiter
    var value = RegExp("" + key + "[^&]+").exec(url);
    // Return the unescaped value minus everything starting from the equals sign or an empty string
    return unescape(!!value ? value.toString().replace(/^[^=]+./, "") : "");
}
